import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

// Components
import {
  U21Loading,
  U21Spacer,
  U21LoadError,
} from 'app/shared/u21-ui/components';

import { PriorAlerts } from 'app/modules/alerts/components/AlertDetails/PriorActivity/PriorAlerts';
import { PriorCases } from 'app/modules/alerts/components/AlertDetails/PriorActivity/PriorCases';
import { PriorSARs } from 'app/modules/alerts/components/AlertDetails/PriorActivity/PriorSARs';

// Hooks
import { useGetAlertPriorActivity } from 'app/modules/alerts/queries/useGetAlertPriorActivity';

export const PriorActivity = () => {
  const { pathname } = useLocation();
  const alertId: number | undefined = useMemo(() => {
    const pathId = Number(pathname.split('/')[2]);
    if (!isNaN(pathId)) {
      return pathId;
    }
    return undefined;
  }, [pathname]);
  const { data, isLoading, isError, refetch } = useGetAlertPriorActivity(
    alertId || -1,
  );

  const associatedAlerts = data?.associated_alerts || [];
  const associatedCases = data?.associated_cases || [];
  const associatedSARs = data?.associated_sars || [];

  if (isLoading) {
    return <U21Loading loading />;
  }

  if (isError) {
    return <U21LoadError label="prior activity" onTryAgain={() => refetch()} />;
  }

  return (
    <U21Spacer spacing={2}>
      <PriorAlerts associatedAlerts={associatedAlerts} />
      <PriorCases associatedCases={associatedCases} />
      <PriorSARs associatedSARs={associatedSARs} />
    </U21Spacer>
  );
};
